import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';

export interface MemberTemplate {
  templateName: string,
  name: string,
  description: string,
  category: string,
}

@Component({
  selector: 'product-template',
  templateUrl: './product-template.component.html',
  styleUrls: ['./product-template.component.scss']
})
export class ProductTemplateComponent implements OnInit {
  @ViewChild('CommonProduct') addProductComponent: AddProductComponent;
  public modalRef: any = null;
  public templateList: Array<any> = [];
  public categoryList: Array<any> = [];
  public duplicateTemplateList: Array<any> = [];
  // public templateCategoryList: Array<any> = [];
  public selectedTemplate: any = '';
  public selectedCategory: any = '';
  // public selectedGroupTemplate: any = '';
  public currentAction: any = '';
  public newTemplateCategoryName: any = '';

  constructor(private modalService: NgbModal, private auth: AuthServiceService, private toastr: ToastrService,public commonService: CommonService,) {
    
    this._getCategoryList();
   }

  ngOnInit(): void {
   this._getTemplateList();
    //this.getAllCategory();
  }

  public formAction(action): void {
    this.currentAction = action;
    if (action == 'create') {
      if (this.selectedCategory) {
        this.addProductComponent.editprodForm.get('name').setValue('');
        this.addProductComponent.editprodForm.get('descp').setValue('');
        this.addProductComponent.editprodForm.get('templateName').setValue('');
        this.addProductComponent.selectedCatId = this.selectedCategory.categorieChildId;
        this.addProductComponent.selectedCategoryId = this.selectedCategory.categorieChildId;
        this.addProductComponent.selectedCategoryNameForDD = this.selectedCategory.categoryName;
        this.addProductComponent.modalService.open(this.addProductComponent.editProduct, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
        
    
      } else {
        this.toastr.error("Select Template Category!");
      }

    } else if (action == 'edit' && this.selectedTemplate ) {
      this._patchForm();
      this.addProductComponent.modalService.open(this.addProductComponent.editProduct, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
      
    } else if (action == 'view' && this.selectedTemplate) {
      this.addProductComponent.modalService.open(this.addProductComponent.editProduct, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
    } else if (action == 'delete' && this.selectedTemplate) {
      this.auth.deleteMemberTemplate(this.selectedTemplate).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this._getTemplateList();
      });
    } else {
      this.toastr.error("select Category/Template!!");
    }

  }

  private _patchForm() {
    let selectedTemplate: MemberTemplate = this.templateList.find((i) => i.id == this.selectedTemplate);
    this.addProductComponent.editprodForm.get('name').setValue(selectedTemplate.name);
    this.addProductComponent.editprodForm.get('descp').setValue(selectedTemplate.description);
    this.addProductComponent.editprodForm.get('templateName').setValue(selectedTemplate.templateName);
    this.addProductComponent.selectedCatId = selectedTemplate?.category;
    this.addProductComponent.selectedCategoryNameForDD = this.commonService.getCategoryName( selectedTemplate?.category);
  }

  public templateEvent(event: { action: string, data: MemberTemplate }) {
    if (event.action == 'save') {
      if (this._isValidData(event.data)) {
        (this.currentAction == 'edit') ? event.data['id'] = this.selectedTemplate : '';
        this.auth.addMemberTemplate({ ...event.data}).subscribe((resp: ApiResponse) => {
          this.modalService.dismissAll();
          this.toastr.success(resp.message);
          this._getTemplateList();
        });
      }
    }
  }

  private _isValidData(template: MemberTemplate): boolean {
    if (!template.templateName) {
      this.toastr.error("Enter Template Name");
      return false;
    }
    return true;
  }

  public _getCategoryList(): void {
    this.commonService.categoryList.subscribe((val: any) => {
      this.categoryList = val.map((e) => {
        return {
          keyName: e.name,
          sub: e.subCategory.map((i) => ({
            keyName: i.categoryName,
            ...i,
          }))
        }

      });
    });
  }

  public _getTemplateList(): void {
    this.templateList = [];
    this.auth.getAllMemberTemplate().subscribe((resp: ApiResponse) => {
      this.duplicateTemplateList = resp.body;
      this.templateList = this.duplicateTemplateList.filter((i: any) => i?.category == this.selectedCategory.categorieChildId).map((i:any)=>{
        return {...i,keyName:i.templateName}
      });
     // this.onCategoryChange();
    });
  }

  public addTemplateCategory() {
    this.auth.addMemberTemplateCategory({ name: this.newTemplateCategoryName }).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      //this.getAllCategory();
      this.modalRef.close();
    });
  }

  public openAddCategoryModal(modal) {
    this.newTemplateCategoryName = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  // public getAllCategory() {
  //   this.auth.getAllMemberTemplateCategory().subscribe((resp: ApiResponse) => {
  //     this.templateCategoryList = resp.body;
  //     this.selectedGroupTemplate = '';
  //   });
  // }

  // public deleteCategory() {
  //   if (this.selectedGroupTemplate) {
  //     this.auth.deleteMemberTemplateCategory(this.selectedGroupTemplate).subscribe((resp: ApiResponse) => {
  //       this.toastr.success(resp.message);
  //       this.getAllCategory();
  //     });
  //   } else {
  //     this.toastr.error("Select Category!");
  //   }
  // }

  public onCategoryChange(selected) {
    this.selectedTemplate = '';
    this.selectedCategory = selected;

    if (this.selectedCategory) {
      this.templateList = this.duplicateTemplateList.filter((i: any) => i?.category == this.selectedCategory.categorieChildId).map((i:any)=>{
        return {...i,keyName:i.templateName}
      })
    } 
    // else {
    //   this.templateList = [...this.duplicateTemplateList];
    // }
  }

}
